import React from "react";

import gibson from "./images/gibson.png";
import guitarraelectrica from "./images/guitarraelectrica.png";
import guitarraelectricaprs from "./images/guitarraelectricaprs.png";
import ibanez from "./images/ibanez.png";
import lespaul from "./images/lespaul.png";
import vanhalen from "./images/vanhalen.png";
import bateria1tom from "./images/bateria1tom.png";
import bateria2bombo from "./images/bateria2bombo.png";
import bateria2tom from "./images/bateria2tom.png";
import bateria3tom from "./images/bateria3tom.png";
import bateria4tom from "./images/bateria4tom.png";
import bateria5tom from "./images/bateria5tom.png";
import bajogl from "./images/bajog&l.png";
import fender from "./images/fender.png";
import fenderviolet from "./images/fenderviolet.png";
import gl from "./images/g&l.png";
import ibanezbass from "./images/ibanezbass.png";
import ibanezbasses from "./images/ibanezbasses.png";
import korg from "./images/korg.png";
import montage from "./images/montage.png";
import motif from "./images/motif.png";
import nordstage from "./images/nordstage.png";
import roland from "./images/roland.png";
import roland2 from "./images/roland2.png";
import monitordb from "./images/monitordb.png";
import monitordbL from "./images/monitordbL.png";
import monitor from "./images/monitor.png";
import monitorL from "./images/monitorL.png";
import sidefill4 from "./images/sidefill4.png";
import sidefill4L from "./images/sidefill4L.png";
import sidefillarray from "./images/sidefillarray.png";
import sidefillarrayL from "./images/sidefillarrayL.png";
import sidefillpuntual from "./images/sidefillpuntual.png";
import sidefillpuntualL from "./images/sidefillpuntualL.png";
import sidefillt from "./images/sidefillt.png";
import sidefilltL from "./images/sidefilltL.png";
import sidetw from "./images/sidetw.png";
import sidetwL from "./images/sidetwL.png";
import substanitch from "./images/substanitch.png";
import substanitchL from "./images/substanitchL.png";
import c3500 from "./images/c3500.png";
import cl5 from "./images/cl5.png";
import sd10 from "./images/sd10.png";
import wings from "./images/wings.png";
import lv1 from "./images/lv1.png";
import mac from "./images/mac.png";
import corriente from "./images/snakes/corriente.png";
import s6l from "./images/s6l.png";
import sq6 from "./images/sq6.png";
import x32 from "./images/x32.png";
import snake8cha from "./images/snakes/snake8cha.png";
import soundtools from "./images/snakes/soundtools.png";
import snake12cha from "./images/snakes/snake12cha.png";
import directbox1 from "./images/directbox/directbox1.png";
import directbox2 from "./images/directbox/directbox2.png";
import directbox3 from "./images/directbox/directbox3.png";
import stand from "./images/rfmic/stand.png";
import stand1 from "./images/rfmic/stand1.png";
import stand2 from "./images/rfmic/stand2.png";
import mano from "./images/rfmic/mano.png";
import manoshure from "./images/rfmic/manoshure.png";
import sm58 from "./images/rfmic/sm58.png";
import antena1 from "./images/rfmic/antena1.png";
import antena from "./images/rfmic/antena.png";
import helicoidal from "./images/rfmic/helicoidal.png";
import antena1L from "./images/rfmic/antena1L.png";
import antenaL from "./images/rfmic/antenaL.png";
import helicoidalL from "./images/rfmic/helicoidalL.png";
import congadoble from "./images/Percu/congadoble.png";
import congadoble2 from "./images/Percu/congadoble2.png";
import accesorios from "./images/Percu/accesorios.png";
import bongo1 from "./images/Percu/bongo1.png";
import conga1 from "./images/Percu/conga1.png";
import conga2 from "./images/Percu/conga2.png";
import conga3 from "./images/Percu/conga3.png";
import block from "./images/Percu/block.png";
import bongo3 from "./images/Percu/bongo3.png";
import cajon1 from "./images/Percu/cajon1.png";
import cajon from "./images/Percu/cajon.png";
import saxofon from "./images/vientos/saxofon.png";
import trompeta from "./images/vientos/trompeta.png";
import trombom from "./images/vientos/trombom.png";
import chime from "./images/Percu/chime.png";
import cowbell from "./images/Percu/cowbell.png";
import darbuka from "./images/Percu/darbuka.png";
import djembe from "./images/Percu/djembe.png";
import djembe2 from "./images/Percu/djembe2.png";
import guira from "./images/Percu/guira.png";
import guira2 from "./images/Percu/guira2.png";
import guiro from "./images/Percu/guiro.png";
import hoopdrum from "./images/Percu/hoopdrum.png";
import maraca1 from "./images/Percu/maraca1.png";
import shaker from "./images/Percu/shaker.png";
import shekere from "./images/Percu/shekere.png";
import tambourine from "./images/Percu/tambourine.png";
import tambourine2 from "./images/Percu/tambourine2.png";
import timbal1 from "./images/Percu/timbal1.png";
import timbal2 from "./images/Percu/timbal2.png";
import triplebell from "./images/Percu/triplebell.png";
import moni from "./images/moni.png";
import monito from "./images/monito.png";
import monitoL from "./images/monitoL.png";
import peitsch from "./images/peitsch.png";
import side2 from "./images/side2.png";
import side2L from "./images/side2L.png";
import sonata from "./images/sonata.png";
import sonataL from "./images/sonataL.png";
import stanitchL from "./images/stanitchL.png";
import stanitch from "./images/stanitch.png";
import stsL from "./images/stsL.png";
import sts from "./images/sts.png";
import tuba from "./images/vientos/tuba.png";
import clarinete from "./images/vientos/clarinete.png";
import flauta from "./images/vientos/flauta.png";
import Charcheta from "./images/vientos/Charcheta-saxor-armonia.png";
import QUENA from "./images/vientos/QUENA.png";
import quena1 from "./images/vientos/quena1.png";
import saxoalto from "./images/vientos/saxoalto.png";
import saxosoprano from "./images/vientos/saxosoprano.png";
import saxotenor from "./images/vientos/saxotenor.png";
import SIKU from "./images/vientos/SIKU.png";
import SIKU2 from "./images/vientos/SIKU2.png";
import ZAMPOÑA from "./images/vientos/ZAMPOÑA.png";
import ÑOLKIN from "./images/vientos/ÑOLKIN.png";
import flauta3 from "./images/vientos/flauta3.png";
import trutuka from "./images/vientos/trutuka.png";
import armonica from "./images/vientos/armonica.png";
import PIFILKA from "./images/vientos/PIFILKA.png";
import zurdo from "./images/Percu/zurdo.png";
import TAMBORADOMINICANA from "./images/Percu/TAMBORADOMINICANA.png";
import tambores from "./images/Percu/tambores.png";
import PLATILLO from "./images/Percu/PLATILLO.png";
import hihat1 from "./images/Percu/hihat1.png";
import REDOBLANTE from "./images/Percu/REDOBLANTE.png";
import bomboleguero from "./images/Percu/bomboleguero.png";
import kultrum from "./images/Percu/kultrum.png";
import bateriaelectronica from "./images/Percu/bateriaelectronica.png";
import pezuñas from "./images/Percu/pezuñas.jpg";
import palodelluvia from "./images/Percu/palodelluvia.png";
import OCTAPAD from "./images/Percu/OCTAPAD.jpg";
import charango from "./images/cuerdas/charango.png";
import violin2 from "./images/cuerdas/violin2.png";
import violin1 from "./images/cuerdas/violin1.png";
import VIOLIN from "./images/cuerdas/VIOLIN.png";
import RONROCO from "./images/cuerdas/RONROCO.png";
import guitarra1 from "./images/cuerdas/guitarra1.png";
import guitarra from "./images/cuerdas/guitarra.png";
import cuatro from "./images/cuerdas/cuatro.png";
import ARPA from "./images/cuerdas/ARPA.png";
import ACORDEON from "./images/acordeon/ACORDEON.png";
import bandoneon1 from "./images/acordeon/bandoneon1.png";
import bandoneon from "./images/acordeon/bandoneon.png";
import acordeon1 from "./images/acordeon/acordeon1.png";
import palinear from "./images/palinear.png";
import palinearL from "./images/palinearL.png";
import sublinear from "./images/sublinear.png";
import sublinearL from "./images/sublinearL.png";
import silla from "./images/silla.png";
import accesorios1 from "./images/accesorios.png";
import solidrums from "./images/Percu/solidrums.png";
import solidrums2 from "./images/Percu/solidrums2.png";
import solidrums3 from "./images/Percu/solidrums3.png";
import TamboradegaitaZuliana from "./images/Percu/TamboradegaitaZuliana.png";
import tamboramexicana from "./images/Percu/tambora-mexicana.png";
import tamborescumaco from "./images/Percu/tamborescumaco.png";
import amplificador from "./images/directbox/amplificador.png";
import cajadirecta from "./images/directbox/cajadirecta.png";
import pasiva from "./images/directbox/pasiva.png";
import cajadirecta1 from "./images/directbox/cajadirecta1.png";
import spliter from "./images/directbox/spliter.png";
import fender1 from "./images/ampgtr/fender.png";
import marshall from "./images/ampgtr/marshall.png";
import vox from "./images/ampgtr/vox.png";
import orangepantalla from "./images/ampgtr/orangepantalla.png";
import orangecabezal from "./images/ampgtr/orangecabezal.png";
import gabinetemarshall from "./images/ampgtr/gabinetemarshall.png";
import cabezal from "./images/ampgtr/cabezal.png";
import ampegcabezal from "./images/ampbajo/ampegcabezal.png";
import aguilarcabezal from "./images/ampbajo/aguilarcabezal.png";
import ampegpantalla2 from "./images/ampbajo/ampegpantalla2.png";
import amphartec from "./images/ampbajo/amphartec.png";
import amphartec2 from "./images/ampbajo/amphartec2.png";
import ampmark from "./images/ampbajo/ampmark.png";
import ampegamp from "./images/ampbajo/ampegamp.png";
import ampegcmbo from "./images/ampbajo/ampegcmbo.png";
import ampegpantalla from "./images/ampbajo/ampegpantalla.png";
import GaetanoBC from "./images/ampbajo/GaetanoBC-150-bajo.png";
import GaetanoBT from "./images/ampbajo/Gaetano-bajo-BT-450.png";
import Apollo from "./images/ampgtr/Gaetano-Apollo-18-gtr.png";
import GTO from "./images/ampgtr/Gaetano-GTO-series-gtr.png";
import mandolinmandolina from "./images/cuerdas/mandolin-mandolina.png";
import Vihuela from "./images/cuerdas/Vihuela.png";
import guitarron from "./images/cuerdas/guitarron.png";
import Guitarra2 from "./images/cuerdas/Guitarra2.png";
import MANDOLINA from "./images/cuerdas/MANDOLINA.png";
import mr18 from "./images/mr18.png";
import Soundgraft from "./images/Soundgraft-ui24.png";
import corriente1 from "./images/corriente.png";
import BOMBOFOLCLORICO from "./images/Percu/BOMBOFOLCLORICO.png";
import BOMBOITALAQUE from "./images/Percu/BOMBOITALAQUE.png";
import ZAMPOÑACROMATICA from "./images/vientos/ZAMPOÑACROMATICA.png";
import tarka from "./images/tarka.png";
import MOSEÑO from "./images/vientos/MOSEÑO.png";
import pedal1 from "./images/ampbajo/pedal1.png";
import pedal2 from "./images/ampbajo/pedal2.png";
import pedal8 from "./images/ampbajo/pedal8.png";
import pedal11 from "./images/ampbajo/pedal11.png";
import pedal12 from "./images/ampbajo/pedal12.png";
import flecha from "./images/flecha.png";
import flecha1 from "./images/flecha1.png";
import flecha2 from "./images/flecha2.png";
import flecha3 from "./images/flecha3.png";
import flecha4 from "./images/flecha4.png";
import linea from "./images/linea.png";
import linea1 from "./images/linea1.png";
import linea2 from "./images/linea2.png";
import linea3 from "./images/linea3.png";
import linea4 from "./images/linea4.png";
import linea5 from "./images/linea5.png";
import tarima from "./images/tarima.png";
import tarima1 from "./images/tarima1.png";
import alfombra from "./images/alfombra.png";
import alfombra2 from "./images/alfombra2.png";
import multipin from "./images/multipin.png";
import pasacable from "./images/pasacable.png";
import mikra8 from "./images/sts/mikra8.png";
import mikra8L from "./images/sts/mikra8L.png";
import monitorsts from "./images/sts/monitor.png";
import monitorstsL from "./images/sts/monitorL.png";
import stsmoni from "./images/sts/sts.png";
import sts1 from "./images/sts/sts1.png";
import sts1L from "./images/sts/sts1L.png";
import substs from "./images/sts/sub.png";
import substsL from "./images/sts/subL.png";
import v7 from "./images/sts/v7.png";
import v7L from "./images/sts/v7L.png";
import v10 from "./images/sts/v10.png";
import v10L from "./images/sts/v10L.png";
import v101 from "./images/sts/v101.png";
import v101L from "./images/sts/v101L.png";
import v102 from "./images/sts/v102.png";
import v102L from "./images/sts/v102L.png";
import condenser from "./images/nuevas/CONDENSER/condenser.png";
import condenser1 from "./images/nuevas/CONDENSER/condenser1.png";
import condenser2 from "./images/nuevas/CONDENSER/condenser2.png";
import condenser3 from "./images/nuevas/CONDENSER/condenser3.png";
import condenser4 from "./images/nuevas/CONDENSER/condenser4.png";
import condenser5 from "./images/nuevas/CONDENSER/condenser5.png";
import condenser6 from "./images/nuevas/CONDENSER/condenser6.png";
import condenser7 from "./images/nuevas/CONDENSER/condenser7.png";
import condenser8 from "./images/nuevas/CONDENSER/condenser8.png";
import condenser9 from "./images/nuevas/CONDENSER/condenser9.png";
import condenser10 from "./images/nuevas/CONDENSER/condenser10.png";
import condenser11 from "./images/nuevas/CONDENSER/condenser11.png";
import condenser12 from "./images/nuevas/CONDENSER/condenser12.png";
import condenser13 from "./images/nuevas/CONDENSER/condenser13.png";
import sm57 from "./images/nuevas/CONDENSER/sm57.png";
import wingbehringer from "./images/nuevas/DIGITALES/wingbehringer.png";
import x32producer from "./images/nuevas/DIGITALES/x32producer.png";
import x32rack from "./images/nuevas/DIGITALES/x32rack.png";
import dj1 from "./images/nuevas/DJ/dj1.png";
import dj2 from "./images/nuevas/DJ/dj2.png";
import dj3 from "./images/nuevas/DJ/dj3.png";
import dj4 from "./images/nuevas/DJ/dj4.png";
import dj5 from "./images/nuevas/DJ/dj5.png";
import dj6 from "./images/nuevas/DJ/dj6.png";
import dj7 from "./images/nuevas/DJ/dj7.png";
import dj8 from "./images/nuevas/DJ/dj8.png";
import dj9 from "./images/nuevas/DJ/dj9.png";
import dj10 from "./images/nuevas/DJ/dj10.png";
import dj11 from "./images/nuevas/DJ/dj11.png";
import dj12 from "./images/nuevas/DJ/dj12.png";
import dj13 from "./images/nuevas/DJ/dj13.png";
import dj14 from "./images/nuevas/DJ/dj14.png";
import dj15 from "./images/nuevas/DJ/dj15.png";
import dj16 from "./images/nuevas/DJ/dj16.png";
import dj17 from "./images/nuevas/DJ/dj17.png";
import dj18 from "./images/nuevas/DJ/dj18.png";
import GUITARRABAJOSEXTO from "./images/nuevas/MEXICANOS/GUITARRABAJOSEXTO.png";
import GUITARRABAJOSEXTO1 from "./images/nuevas/MEXICANOS/GUITARRABAJOSEXTO1.png";
import GUITARRABAJOSEXTO2 from "./images/nuevas/MEXICANOS/GUITARRABAJOSEXTO2.png";
import GUITARRON from "./images/nuevas/MEXICANOS/GUITARRON.png";
import VIHUELA from "./images/nuevas/MEXICANOS/VIHUELA.png";
import AFUXÉCABAÇA from "./images/nuevas/BRASILEROS/AFUXÉ-CABAÇA.png";
import AFUXÉCABAÇA1 from "./images/nuevas/BRASILEROS/AFUXÉ-CABAÇA1.png";
import AFUXÉCABAÇA2 from "./images/nuevas/BRASILEROS/AFUXÉ-CABAÇA2.png";
import AFUXÉCABAÇA3 from "./images/nuevas/BRASILEROS/AFUXÉ-CABAÇA3.png";
import AFUXÉCABAÇA4 from "./images/nuevas/BRASILEROS/AFUXÉ-CABAÇA4.png";
import AGOGÔDUPLO from "./images/nuevas/BRASILEROS/AGOGÔ-DUPLO.png";
import AGOGÔDUPLO1 from "./images/nuevas/BRASILEROS/AGOGÔ-DUPLO1.png";
import AGOGÔTRIPLO2 from "./images/nuevas/BRASILEROS/AGOGÔ-TRIPLO2.png";
import AGOGÔTRIPLO3 from "./images/nuevas/BRASILEROS/AGOGÔ-TRIPLO3.png";
import BANJO from "./images/nuevas/BRASILEROS/BANJO.png";
import BERIMBAU from "./images/nuevas/BRASILEROS/BERIMBAU.png";
import BERIMBAU1 from "./images/nuevas/BRASILEROS/BERIMBAU1.png";
import BERIMBAU2 from "./images/nuevas/BRASILEROS/BERIMBAU2.png";
import CAIXAREPIQUE1 from "./images/nuevas/BRASILEROS/CAIXA-REPIQUE1.png";
import CAIXAREPIQUE2 from "./images/nuevas/BRASILEROS/CAIXA-REPIQUE2.png";
import CAVAQUINHO from "./images/nuevas/BRASILEROS/CAVAQUINHO.png";
import CAVAQUINHO2 from "./images/nuevas/BRASILEROS/CAVAQUINHO2.png";
import CUICA from "./images/nuevas/BRASILEROS/CUICA.png";
import CUICA1 from "./images/nuevas/BRASILEROS/CUICA1.png";
import GANZÁ from "./images/nuevas/BRASILEROS/GANZÁ.png";
import GANZÁ1 from "./images/nuevas/BRASILEROS/GANZÁ1.png";
import GANZÁDEPLATINELA from "./images/nuevas/BRASILEROS/GANZÁDEPLATINELA.png";
import GANZÁDEPLATINELA1 from "./images/nuevas/BRASILEROS/GANZÁDEPLATINELA1.png";
import GANZAXÉ from "./images/nuevas/BRASILEROS/GANZAXÉ.png";
import PANDEIRO from "./images/nuevas/BRASILEROS/PANDEIRO.png";
import PANDEIRO1 from "./images/nuevas/BRASILEROS/PANDEIRO1.png";
import REBOLO from "./images/nuevas/BRASILEROS/REBOLO.png";
import RECORECO1 from "./images/nuevas/BRASILEROS/RECO.RECO1.png";
import RECORECO from "./images/nuevas/BRASILEROS/RECORECO.png";
import REPIQUEDEMÃO from "./images/nuevas/BRASILEROS/REPIQUEDEMÃO.png";
import REPIQUEDEMÃO1 from "./images/nuevas/BRASILEROS/REPIQUEDEMÃO1.png";
import REPIQUEDEMÃO2 from "./images/nuevas/BRASILEROS/REPIQUEDEMÃO2.png";
import SURDO from "./images/nuevas/BRASILEROS/SURDO.png";
import SURDO1 from "./images/nuevas/BRASILEROS/SURDO1.png";
import TAMBORIM from "./images/nuevas/BRASILEROS/TAMBORIM.png";
import TAMBORIM1 from "./images/nuevas/BRASILEROS/TAMBORIM1.png";
import TAMBORIM2 from "./images/nuevas/BRASILEROS/TAMBORIM2.png";
import TAMBORIM3 from "./images/nuevas/BRASILEROS/TAMBORIM3.png";
import TANTAN from "./images/nuevas/BRASILEROS/TAN-TAN.png";
import TANTAN1 from "./images/nuevas/BRASILEROS/TAN-TAN1.png";
import TANTAN2 from "./images/nuevas/BRASILEROS/TAN-TAN2.png";
import TIMBA from "./images/nuevas/BRASILEROS/TIMBA.png";
import TIMBA1 from "./images/nuevas/BRASILEROS/TIMBA1.png";
import TIMBA2 from "./images/nuevas/BRASILEROS/TIMBA2.png";
import TIMBA3 from "./images/nuevas/BRASILEROS/TIMBA3.png";
import TIMBAL from "./images/nuevas/BRASILEROS/TIMBAL.png";
import TIMBAL1 from "./images/nuevas/BRASILEROS/TIMBAL1.png";
import UKULELE from "./images/nuevas/BRASILEROS/UKULELE.png";
import UKULELE1 from "./images/nuevas/BRASILEROS/UKULELE1.png";
import VIOLACAIPIRA from "./images/nuevas/BRASILEROS/VIOLA-CAIPIRA.png";
import VIOLACAIPIRA1 from "./images/nuevas/BRASILEROS/VIOLA-CAIPIRA1.png";
import VIOLÃO from "./images/nuevas/BRASILEROS/VIOLÃO.png";
import VIOLÃODEAÇO from "./images/nuevas/BRASILEROS/VIOLÃODEAÇO.png";
import ACORDEONn from "./images/nuevas/SINFONICA/ACORDEON.png";
import ACORDEON1 from "./images/nuevas/SINFONICA/ACORDEON1.png";
import ACORDEON2 from "./images/nuevas/SINFONICA/ACORDEON2.png";
import ACORDEON3 from "./images/nuevas/SINFONICA/ACORDEON3.png";
import ACORDEON4 from "./images/nuevas/SINFONICA/ACORDEON4.png";
import ARPAA from "./images/nuevas/SINFONICA/ARPA.png";
import ARPA2 from "./images/nuevas/SINFONICA/ARPA2.png";
import BARITONO from "./images/nuevas/SINFONICA/BARITONO.png";
import BARITONO1 from "./images/nuevas/SINFONICA/BARITONO1.png";
import CONCERTINA from "./images/nuevas/SINFONICA/CONCERTINA.png";
import CONCERTINA1 from "./images/nuevas/SINFONICA/CONCERTINA1.png";
import CONTRABAJO from "./images/nuevas/SINFONICA/CONTRABAJO.png";
import CORNOFRANCES from "./images/nuevas/SINFONICA/CORNO-FRANCES.png";
import CORNOFRANCES2 from "./images/nuevas/SINFONICA/CORNO-FRANCES2.png";
import CORNOINGLES from "./images/nuevas/SINFONICA/CORNO-INGLES.png";
import EUPHONIUM from "./images/nuevas/SINFONICA/EUPHONIUM.png";
import EUPHONIUM1 from "./images/nuevas/SINFONICA/EUPHONIUM1.png";
import FAGOT from "./images/nuevas/SINFONICA/FAGOT.png";
import FLAUTATRAVERSA from "./images/nuevas/SINFONICA/FLAUTA-TRAVERSA.png";
import FLAUTINPICCOLO from "./images/nuevas/SINFONICA/FLAUTIN-PICCOLO.png";
import GAITA from "./images/nuevas/SINFONICA/GAITA.png";
import GONG from "./images/nuevas/SINFONICA/GONG.png";
import GONG1 from "./images/nuevas/SINFONICA/GONG1.png";
import GONG2 from "./images/nuevas/SINFONICA/GONG2.png";
import HARMÓNICA from "./images/nuevas/SINFONICA/HARMÓNICA.png";
import MARIMBA from "./images/nuevas/SINFONICA/MARIMBA.png";
import MARIMBA1 from "./images/nuevas/SINFONICA/MARIMBA1.png";
import MARIMBA2 from "./images/nuevas/SINFONICA/MARIMBA2.png";
import MARIMBA3 from "./images/nuevas/SINFONICA/MARIMBA3.png";
import MELÓDICA from "./images/nuevas/SINFONICA/MELÓDICA.png";
import MELÓDICA1 from "./images/nuevas/SINFONICA/MELÓDICA1.png";
import OBOÉ from "./images/nuevas/SINFONICA/OBOÉ.png";
import OCARINA from "./images/nuevas/SINFONICA/OCARINA.png";
import OCARINA1 from "./images/nuevas/SINFONICA/OCARINA1.png";
import PLATILLOS from "./images/nuevas/SINFONICA/PLATILLOS.png";
import PLATILLOS1 from "./images/nuevas/SINFONICA/PLATILLOS1.png";
import SAXOBARITONO from "./images/nuevas/SINFONICA/SAXO-BARITONO.png";
import SAXOSOPRANO from "./images/nuevas/SINFONICA/SAXO-SOPRANO.png";
import SITARA from "./images/nuevas/SINFONICA/SITARA.png";
import TIMPANO from "./images/nuevas/SINFONICA/TIMPANO.png";
import TIMPANO1 from "./images/nuevas/SINFONICA/TIMPANO1.png";
import TIMPANO2 from "./images/nuevas/SINFONICA/TIMPANO2.png";
import TIMPANO3 from "./images/nuevas/SINFONICA/TIMPANO3.png";
import TRIANGULO from "./images/nuevas/SINFONICA/TRIANGULO.png";
import TRIANGULO1 from "./images/nuevas/SINFONICA/TRIANGULO1.png";
import VIOLONCHELLO from "./images/nuevas/SINFONICA/VIOLONCHELLO.png";
import VIOLONCHELLO1 from "./images/nuevas/SINFONICA/VIOLONCHELLO1.png";
import XILOFON from "./images/nuevas/SINFONICA/XILOFON.png";
import XILOFON1 from "./images/nuevas/SINFONICA/XILOFON1.png";
import PANTALLA from "./images/PANTALLA.png";
import PANTALLA1 from "./images/PANTALLA1.png";
import toms from "./images/toms.png";
import toms1 from "./images/toms1.png";
import tarima2 from "./images/sobretarima2.png";
import uno from "./images/numero/1.png";
import dos from "./images/numero/2.png";
import tres from "./images/numero/3.png";
import cuatro1 from "./images/numero/4.png";
import cinco from "./images/numero/5.png";
import seis from "./images/numero/6.png";
import siete from "./images/numero/7.png";
import ocho from "./images/numero/8.png";
import nueve from "./images/numero/9.png";
import diez from "./images/numero/10.png";
import once from "./images/numero/11.png";
import doce from "./images/numero/12.png";
import trece from "./images/numero/13.png";
import catorce from "./images/numero/14.png";
import quince from "./images/numero/15.png";
import diezseis from "./images/numero/16.png";
import diezsiete from "./images/numero/17.png";
import diezocho from "./images/numero/18.png";
import dieznueve from "./images/numero/19.png";
import veinte from "./images/numero/20.png";
import veinteuno from "./images/numero/21.png";
import veintedos from "./images/numero/22.png";
import veintetres from "./images/numero/23.png";
import veintecuatro from "./images/numero/24.png";
import veintecinco from "./images/numero/25.png";
import veinteseis from "./images/numero/26.png";
import veintesiete from "./images/numero/27.png";
import veinteocho from "./images/numero/28.png";
import veintenueve from "./images/numero/29.png";
import treinta from "./images/numero/30.png";
import treinta1 from "./images/numero/31.png";
import treinta2 from "./images/numero/32.png";
import treinta3 from "./images/numero/33.png";
import treinta4 from "./images/numero/34.png";
import treinta5 from "./images/numero/35.png";
import treinta6 from "./images/numero/36.png";
import treinta7 from "./images/numero/37.png";
import treinta8 from "./images/numero/38.png";
import treinta9 from "./images/numero/39.png";
import cuarenta from "./images/numero/40.png";
import cuarenta1 from "./images/numero/41.png";
import cuarenta2 from "./images/numero/42.png";
import cuarenta3 from "./images/numero/43.png";
import cuarenta4 from "./images/numero/44.png";
import cuarenta5 from "./images/numero/45.png";
import cuarenta6 from "./images/numero/46.png";
import cuarenta7 from "./images/numero/47.png";
import cuarenta8 from "./images/numero/48.png";
import cuarenta9 from "./images/numero/49.png";
import cincuenta from "./images/numero/50.png";
import cincuenta1 from "./images/numero/51.png";
import cincuenta2 from "./images/numero/52.png";
import cincuenta3 from "./images/numero/53.png";
import cincuenta4 from "./images/numero/54.png";
import cincuenta5 from "./images/numero/55.png";
import cincuenta6 from "./images/numero/56.png";
import cincuenta7 from "./images/numero/57.png";
import cincuenta8 from "./images/numero/58.png";
import cincuenta9 from "./images/numero/59.png";
import sesenta from "./images/numero/60.png";
import sesenta1 from "./images/numero/61.png";
import sesenta2 from "./images/numero/62.png";
import sesenta3 from "./images/numero/63.png";
import sesenta4 from "./images/numero/64.png";
import sesenta5 from "./images/numero/65.png";
import sesenta6 from "./images/numero/66.png";
import sesenta7 from "./images/numero/67.png";
import sesenta8 from "./images/numero/68.png";
import sesenta9 from "./images/numero/69.png";
import setenta from "./images/numero/70.png";
import setenta1 from "./images/numero/71.png";
import setenta2 from "./images/numero/72.png";
import setenta3 from "./images/numero/73.png";
import setenta4 from "./images/numero/74.png";
import setenta5 from "./images/numero/75.png";
import setenta6 from "./images/numero/76.png";
import setenta7 from "./images/numero/77.png";
import setenta8 from "./images/numero/78.png";
import setenta9 from "./images/numero/79.png";
import ochenta from "./images/numero/80.png";
import ochenta1 from "./images/numero/81.png";
import ochenta2 from "./images/numero/82.png";
import ochenta3 from "./images/numero/83.png";
import ochenta4 from "./images/numero/84.png";
import ochenta5 from "./images/numero/85.png";
import ochenta6 from "./images/numero/86.png";
import ochenta7 from "./images/numero/87.png";
import ochenta8 from "./images/numero/88.png";
import ochenta9 from "./images/numero/89.png";
import noventa from "./images/numero/90.png";
import noventa1 from "./images/numero/91.png";
import noventa2 from "./images/numero/92.png";
import noventa3 from "./images/numero/93.png";
import noventa4 from "./images/numero/94.png";
import noventa5 from "./images/numero/95.png";
import noventa6 from "./images/numero/96.png";
import noventa7 from "./images/numero/97.png";
import noventa8 from "./images/numero/98.png";
import noventa9 from "./images/numero/99.png";
import cien from "./images/numero/100.png";
import p1 from "./images/directbox/p1.png";
import p2 from "./images/directbox/p2.png";
import zed1 from "./images/directbox/zed2.png";
import zed2 from "./images/directbox/consolazed.png";
import iem2050 from "./images/rfmic/2050.png";
import iem1000 from "./images/rfmic/psm10001.png";
import body1 from "./images/rfmic/body.png";
import body2 from "./images/rfmic/body2.png";
import body3 from "./images/rfmic/body3.png";
import body4 from "./images/rfmic/iem2.png";
import body5 from "./images/rfmic/iem3.png";
import body6 from "./images/rfmic/psm1000.png";
import turizo from "./images/turizo.png";
import mau from "./images/mau.png";
import zedgrande from "./images/zedgrande.png";
import pasacable2 from "./images/pasacable2.png";
import camilo from "./images/camilo.png";
import lebon from "./images/lebon.png";
import morelo from "./images/morelo.png";
import jam from "./images/jam.png";
import julian from "./images/julian.png";
import zen from "./images/zen.png";
import DiegoALaVoz from "./images/DiegoALaVoz.png";
import AlexLaar from "./images/AlexLaar.png";
import mujer from "./images/mujer.png";
import hombre from "./images/hombre.png";
import hombre1 from "./images/hombre1.png";
import baila1 from "./images/baile/baila1.png";
import baila2 from "./images/baile/baila2.png";
import baila3 from "./images/baile/baila3.png";
import baila4 from "./images/baile/baila4.png";
import person1 from "./images/personas/person1.png";
import person2 from "./images/personas/person2.png";
import person3 from "./images/personas/person3.png";
import person4 from "./images/personas/person4.png";
import person5 from "./images/personas/person5.png";
import person6 from "./images/personas/person6.png";
import person7 from "./images/personas/person7.png";
import person8 from "./images/personas/person8.png";
import person9 from "./images/personas/person9.png";
import person10 from "./images/personas/person10.png";
import person11 from "./images/personas/person11.png";
import person12 from "./images/personas/person12.png";
import person13 from "./images/personas/person13.png";
import person14 from "./images/personas/person14.png";
import person15 from "./images/personas/person15.png";
import person16 from "./images/personas/person16.png";
import person17 from "./images/personas/person17.png";
import person18 from "./images/personas/person18.png";
import cryo from "./images/fx/cryo.png";
import cryo1 from "./images/fx/cryo1.png";
import fuego from "./images/fx/fuego.png";
import fuego1 from "./images/fx/fuego1.png";
import barra from "./images/luces/barra.png";
import barra1 from "./images/luces/barra1.png";
import barra2 from "./images/luces/barra2.png";
import barra3 from "./images/luces/barra3.png";
import flash from "./images/luces/flash.png";
import led from "./images/luces/led.png";
import leko from "./images/luces/leko.png";
import LEKO3 from "./images/luces/LEKO3.png";
import LEKO4 from "./images/luces/LEKO4.png";
import LEKO5 from "./images/luces/LEKO5.png";
import luz from "./images/luces/luz.png";
import luz1 from "./images/luces/luz1.png";
import luz2 from "./images/luces/luz2.png";
import luz3 from "./images/luces/luz3.png";
import luz4 from "./images/luces/luz4.png";
import luz5 from "./images/luces/luz5.png";
import luz6 from "./images/luces/luz6.png";
import luz7 from "./images/luces/luz7.png";
import luz8 from "./images/luces/luz8.png";
import luz9 from "./images/luces/luz9.png";
import luz10 from "./images/luces/luz10.png";
import luz11 from "./images/luces/luz11.png";
import luz12 from "./images/luces/luz12.png";
import minibrut from "./images/luces/minibrut.png";
import minibrut1 from "./images/luces/minibrut1.png";
import movil from "./images/luces/movil.png";
import movilbeam from "./images/luces/movilbeam.png";
import movilbeam1 from "./images/luces/movilbeam1.png";
import escalera from "./images/estructura/escalera.png";
import escalera1 from "./images/estructura/escalera1.png";
import escalera2 from "./images/estructura/escalera2.png";
import escalera3 from "./images/estructura/escalera3.png";
import escalera4 from "./images/estructura/escalera4.png";
import escalera5 from "./images/estructura/escalera5.png";
import tru6 from "./images/estructura/tru6.png";
import trus from "./images/estructura/trus.png";
import trus1 from "./images/estructura/trus1.png";
import trus2 from "./images/estructura/trus2.png";
import trus3 from "./images/estructura/trus3.png";
import trus4 from "./images/estructura/trus4.png";
import trus5 from "./images/estructura/trus5.png";
import trus6 from "./images/estructura/trus6.png";
import trus7 from "./images/estructura/trus7.png";
import valla from "./images/estructura/valla.png";
import trus8 from "./images/estructura/trus8.png";
import trus9 from "./images/estructura/trus9.png";
import trus10 from "./images/estructura/trus10.png";
import trus11 from "./images/estructura/trus11.png";
import trus12 from "./images/estructura/trus12.png";
import trus13 from "./images/estructura/trus13.png";
import trus16 from "./images/estructura/trus16.png";
import trus17 from "./images/estructura/trus17.png";
import trus18 from "./images/estructura/trus18.png";
import trus20 from "./images/estructura/trus20.png";
import trus21 from "./images/estructura/trus21.png";
import trus22 from "./images/estructura/trus22.png";
import layher from "./images/estructura/layher.png";
import layher1 from "./images/estructura/layher1.png";
import layher2 from "./images/estructura/layher2.png";
import layher3 from "./images/estructura/layher3.png";
import layher4 from "./images/estructura/layher4.png";
import layher5 from "./images/estructura/layher5.png";
import layher6 from "./images/estructura/layher6.png";
import layher7 from "./images/estructura/layher7.png";
import layher8 from "./images/estructura/layher8.png";
// import layher9 from "./images/estructura/layher9.png";
// import layher10 from "./images/estructura/layher10.png";
import layher11 from "./images/estructura/layher11.png";
import layher12 from "./images/estructura/layher12.png";
import layher13 from "./images/estructura/layher13.png";
import motor1 from "./images/estructura/motor1.png";
import motor2 from "./images/estructura/motor2.png";
import muro2 from "./images/estructura/muro.png";
import muro3 from "./images/estructura/muro1.png";
import pantallagrande from "./images/estructura/pantallagrande.png";
import pantallagrande1 from "./images/estructura/pantallagrande1.png";
import podio from "./images/estructura/podio.png";
import silla1 from "./images/estructura/silla.png";
import tarima3 from "./images/estructura/tarima3.png";
import tarima4 from "./images/estructura/tarima4.png";
import tarima5 from "./images/estructura/tarima5.png";
import tarima6 from "./images/estructura/tarima6.png";
import pantalla2 from "./images/video/pantalla2.png";
import pantalla3 from "./images/video/pantalla3.png";
import pantall4 from "./images/video/pantall4.png";
import groundsupport from "./images/estructura/groundsupport.png";
import bateriatop from "./images/bateriatop.png";
import bateria1 from "./images/bateria1.png";
import m7 from "./images/m7.png";
import ls9 from "./images/ls9.png";
import octapad from "./images/sinte/octapad.png";
import tche from "./images/sinte/TcHelicon.png";
import korgvocal from "./images/sinte/korgvocal.png";
import moog from "./images/sinte/moog.png";
import polyd from "./images/sinte/polyd.png";
import mikro2 from "./images/sinte/mikro2.png";
import AkaiMpd218 from "./images/sinte/AkaiMpd218.png";
import NordDrum3P from "./images/sinte/NordDrum3P.png";
import baby from "./images/ampbajo/babybass.png";
import baby2 from "./images/ampbajo/babybass2.png";
import baby3 from "./images/ampbajo/babybass3.png";
import abletonpush from "./images/sinte/abletonpush.png";
import novationkeymini from "./images/sinte/novationkeymini.png";
import piano from "./images/piano.png";
import piano2 from "./images/piano2.png";
import event26a from "./images/das/EVENT26A.png";
import event26ar from "./images/das/EVENT26AR.png";
import event26a2 from "./images/das/EVENT26A2.png";
import event26a2r from "./images/das/EVENT26A2R.png";
import event26asideR from "./images/das/EVENT26AsideR.png";
import event26aside from "./images/das/EVENT26Aside.png";
import action525a from "./images/das/ACTION525A.png";
import action525ar from "./images/das/ACTION525Ar.png";
import aero40 from "./images/das/AERO40.png";
import aero40r from "./images/das/AERO40r.png";
import AERO40ARRAY from "./images/das/AERO40ARRAY.png";
import AERO40ARRAYr from "./images/das/AERO40ARRAYr.png";
import AERO50ARRAY from "./images/das/AERO50ARRAY.png";
import AERO50ARRAYr from "./images/das/AERO50ARRAYr.png";
import ALTEACOMBO from "./images/das/ALTEACOMBO.png";
import ALTEACOMBOr from "./images/das/ALTEACOMBOr.png";
import ARCO4T from "./images/das/ARCO4T.png";
import ARCO4Tr from "./images/das/ARCO4Tr.png";
import EVENT26AARRAY from "./images/das/EVENT26AARRAY.png";
import EVENT26AARRAYr from "./images/das/EVENT26AARRAYr.png";
import EVENT26ASTACK from "./images/das/EVENT26ASTACK.png";
import EVENT26ASTACKr from "./images/das/EVENT26ASTACKr.png";
import EVENT210AARRAY from "./images/das/EVENT210AARRAY.png";
import EVENT210AARRAYr from "./images/das/EVENT210AARRAYr.png";
import EVENT210ASTACK from "./images/das/EVENT210ASTACK.png";
import EVENT210ASTACKR from "./images/das/EVENT210ASTACKR.png";
import EVENT212AARRAY from "./images/das/EVENT212AARRAY.png";
import EVENT212AARRAYr from "./images/das/EVENT212AARRAYr.png";
import LX218A from "./images/das/LX218A.png";
import LX218Ar from "./images/das/LX218Ar.png";
import PIEPAR from "./images/das/PIEPAR.png";
import ROAD12A from "./images/das/ROAD12A.png";
import ROAD12Ar from "./images/das/ROAD12Ar.png";
import UX221 from "./images/das/UX221.png";
import UX221r from "./images/das/UX221r.png";
import VANTEC15 from "./images/das/VANTEC15.png";
import VANTEC15r from "./images/das/VANTEC15r.png";
import VANTEC15MONITOR from "./images/das/VANTEC15MONITOR.png";
import VANTEC15MONITORr from "./images/das/VANTEC15MONITORr.png";
import VANTEC20AARRAY from "./images/das/VANTEC20AARRAY.png";
import VANTEC20AARRAYr from "./images/das/VANTEC20AARRAYr.png";
import VANTEC20AARRAYBLANCO from "./images/das/VANTEC20AARRAYBLANCO.png";
import VANTEC20AARRAYBLANCOr from "./images/das/VANTEC20AARRAYBLANCOr.png";
import VANTEC118A from "./images/das/VANTEC118A.png";
import VANTEC118Ar from "./images/das/VANTEC118Ar.png";
import VANTECSIDE from "./images/das/VANTECSIDE.png";
import VANTECSIDEr from "./images/das/VANTECSIDEr.png";
import pierecto from "./images/rfmic/pierecto.png";
import ventury from "./images/fx/ventury.png";
import TV from "./images/3d/TV.png";
import bateria from "./images/3d/bateria.png";
import bateria2 from "./images/3d/bateria1.png";
import bateria3 from "./images/3d/bateria3.png";
import bateria4 from "./images/3d/bateria4.png";
import bateria5 from "./images/3d/bateria5.png";
import bateria6 from "./images/3d/bateria6.png";
import bateriafront from "./images/3d/bateriafront.png";
import bateriaback from "./images/3d/bateriaback.png";
import guitarraacustica from "./images/3d/guitarraacustica.png";
import guitarraup from "./images/3d/guitarraup.png";
import gtrtop from "./images/3d/gtrtop.png";
import criolla from "./images/3d/criolla.png";
import keytop from "./images/3d/keytop.png";
import keyfront from "./images/3d/keyfront.png";
import sinte from "./images/3d/sinte.png";
import sinte1 from "./images/3d/sinte1.png";
import mixer from "./images/3d/mixer.png";
import mixer1 from "./images/3d/mixer1.png";
import amplificador11 from "./images/3d/amplificador.png";
import bass from "./images/3d/bass.png";
import bass2 from "./images/3d/bass2.png";
import bass3 from "./images/3d/bass3.png";
import bass4 from "./images/3d/bass4.png";
import ampli2 from "./images/3d/ampli2.png";
import criolla1 from "./images/3d/criolla1.png";
import criolla2 from "./images/3d/criolla2.png";
import electrica from "./images/3d/electrica.png";
import electrica1 from "./images/3d/electrica1.png";
import electrica2 from "./images/3d/electrica2.png";
import electrica3 from "./images/3d/electrica3.png";
import electrica4 from "./images/3d/electrica4.png";
import bajo from "./images/3d/bajo.png";
import banjo from "./images/3d/banjo.png";
import keygtr from "./images/3d/keygtr.png";
import valla1 from "./images/3d/valla1.png";
import bongo from "./images/3d/bongo.png";
import pandereta from "./images/3d/pandereta.png";
import piano4 from "./images/3d/piano4.png";
import tuba1 from "./images/3d/tuba1.png";
import trompeta1 from "./images/3d/trompeta1.png";
import trombom1 from "./images/3d/trombom1.png";
import apollo from "./images/3d/apollo.png";
import ukelele from "./images/3d/ukelele.png";
import cajon2 from "./images/3d/cajon2.png";
import monitor1 from "./images/3d/monitor1.png";
import monitor2 from "./images/3d/monitor2.png";
import case1 from "./images/3d/case1.png";
import case2 from "./images/3d/case2.png";
import tarima7 from "./images/3d/tarima7.png";
import tarima8 from "./images/3d/tarima8.png";
import tarima9 from "./images/3d/tarima9.png";
import tarima10 from "./images/3d/tarima10.png";
import tarima11 from "./images/3d/tarima11.png";
import tarima12 from "./images/3d/tarima12.png";
import tarimaescalera from "./images/3d/escaleratarima.png";
import tarimaescalera1 from "./images/3d/escaleratarima1.png";
import guiro1 from "./images/3d/guiro1.png";
import piano3 from "./images/3d/piano3.png";
import piano5 from "./images/3d/piano5.png";
import piano6 from "./images/3d/piano6.png";
import cencerro from "./images/3d/cencerro.png";
import campana from "./images/3d/campana.png";
import compu1 from "./images/3d/compu1.png";
import compu2 from "./images/3d/compu2.png";
import atril from "./images/3d/atril.png";
import piedemic from "./images/3d/piedemic.png";
import piedemic1 from "./images/3d/piedemic1.png";
import piedemic3 from "./images/3d/piedemic3.png";
import microfonoshure from "./images/3d/microfonoshure.png";
import pedalera from "./images/3d/pedalera.png";
import pantalla from "./images/3d/pantalla.png";
import mesa from "./images/3d/mesa.png";
import cello from "./images/3d/cello.png";
import conga from "./images/3d/conga.png";
import conga4 from "./images/3d/conga4.png";
import corriente2 from "./images/3d/corriente2.png";
import corriente4 from "./images/3d/corriente4.png";
import dj from "./images/3d/dj.png";
import dj0 from "./images/3d/dj0.png";
import lara from "./images/3d/lara.png";
import laral from "./images/3d/laraL.png";
import sublara from "./images/3d/sublara.png";
import krk from "./images/3d/krk.png";
import flecha5 from "./images/3d/flecha5.png";
import flecha6 from "./images/3d/flecha6.png";
import truss from "./images/3d/truss.png";
import estructura from "./images/3d/estructura.png";
import estructura1 from "./images/3d/estructura1.png";
import setupguitarra from "./images/3d/setupguitarra.png";
import silla2 from "./images/3d/silla2.png";
import octa from "./images/sinte/octa.png";


const images = () => {
  return (
    <>

      <img src={octa} alt="foto" />
      <img src={silla2} alt="foto" />
      <img src={setupguitarra} alt="foto" />
      <img src={estructura1} alt="foto" />
      <img src={estructura} alt="foto" />
      <img src={truss} alt="foto" />
      <img src={flecha6} alt="foto" />
      <img src={flecha5} alt="foto" />
      <img src={krk} alt="foto" />
      <img src={sublara} alt="foto" />
      <img src={lara} alt="foto" />
      <img src={laral} alt="foto" />
      <img src={dj0} alt="foto" />
      <img src={dj} alt="foto" />
      <img src={corriente4} alt="foto" />
      <img src={corriente2} alt="foto" />
      <img src={conga} alt="foto" />
      <img src={conga4} alt="foto" />
      <img src={cello} alt="foto" />
      <img src={mesa} alt="foto" />
      <img src={pantalla} alt="foto" />
      <img src={pedalera} alt="foto" />
      <img src={microfonoshure} alt="foto" />
      <img src={piedemic3} alt="foto" />
      <img src={piedemic1} alt="foto" />
      <img src={piedemic} alt="foto" />
      <img src={atril} alt="foto" />
      <img src={compu2} alt="foto" />
      <img src={compu1} alt="foto" />
      <img src={campana} alt="foto" />
      <img src={cencerro} alt="foto" />
      <img src={piano6} alt="foto" />
      <img src={piano3} alt="foto" />
      <img src={piano5} alt="foto" />
      <img src={guiro1} alt="foto" />
      <img src={tarimaescalera} alt="foto" />
      <img src={tarima12} alt="foto" />
      <img src={tarimaescalera1} alt="foto" />
      <img src={tarima11} alt="foto" />
      <img src={tarima10} alt="foto" />
      <img src={tarima9} alt="foto" />
      <img src={tarima8} alt="foto" />
      <img src={tarima7} alt="foto" />
      <img src={monitor2} alt="foto" />
      <img src={monitor1} alt="foto" />
      <img src={case2} alt="foto" />
      <img src={case1} alt="foto" />
      <img src={cajon2} alt="foto" />
      <img src={ukelele} alt="foto" />
      <img src={apollo} alt="foto" />
      <img src={trombom1} alt="foto" />
      <img src={trompeta1} alt="foto" />
      <img src={tuba1} alt="foto" />
      <img src={piano4} alt="foto" />
      <img src={pandereta} alt="foto" />
      <img src={bongo} alt="foto" />
      <img src={valla1} alt="foto" />
      <img src={keygtr} alt="foto" />
      <img src={banjo} alt="foto" />
      <img src={electrica4} alt="foto" />
      <img src={electrica3} alt="foto" />
      <img src={electrica2} alt="foto" />
      <img src={electrica1} alt="foto" />
      <img src={electrica} alt="foto" />
      <img src={criolla2} alt="foto" />
      <img src={criolla1} alt="foto" />
      <img src={amplificador11} alt="foto" />
      <img src={ampli2} alt="foto" />
      <img src={bass4} alt="foto" />
      <img src={bass3} alt="foto" />
      <img src={bass2} alt="foto" />
      <img src={bass} alt="foto" />
      <img src={bajo} alt="foto" />
      <img src={mixer1} alt="foto" />
      <img src={mixer} alt="foto" />
      <img src={sinte1} alt="foto" />
      <img src={sinte} alt="foto" />
      <img src={keyfront} alt="foto" />
      <img src={keytop} alt="foto" />
      <img src={criolla} alt="foto" />
      <img src={criolla2} alt="foto" />
      <img src={criolla1} alt="foto" />
      <img src={gtrtop} alt="foto" />
      <img src={guitarraup} alt="foto" />
      <img src={guitarraacustica} alt="foto" />
      <img src={bateriaback} alt="foto" />
      <img src={bateriafront} alt="foto" />
      <img src={bateria6} alt="foto" />
      <img src={bateria5} alt="foto" />
      <img src={bateria4} alt="foto" />
      <img src={bateria3} alt="foto" />
      <img src={bateria2} alt="foto" />
      <img src={bateria} alt="foto" />
      <img src={TV} alt="foto" />
      <img src={ventury} alt="foto" />
      <img src={pierecto} alt="foto" />
      <img src={VANTECSIDEr} alt="foto" />
      <img src={VANTECSIDE} alt="foto" />
      <img src={VANTEC118Ar} alt="foto" />
      <img src={VANTEC118A} alt="foto" />
      <img src={VANTEC20AARRAYBLANCOr} alt="foto" />
      <img src={VANTEC20AARRAYBLANCO} alt="foto" />
      <img src={VANTEC20AARRAYr} alt="foto" />
      <img src={VANTEC20AARRAY} alt="foto" />
      <img src={VANTEC15MONITORr} alt="foto" />
      <img src={VANTEC15MONITOR} alt="foto" />
      <img src={VANTEC15r} alt="foto" />
      <img src={VANTEC15} alt="foto" />
      <img src={UX221r} alt="foto" />
      <img src={UX221} alt="foto" />
      <img src={ROAD12A} alt="foto" />
      <img src={ROAD12Ar} alt="foto" />
      <img src={PIEPAR} alt="foto" />
      <img src={LX218Ar} alt="foto" />
      <img src={LX218A} alt="foto" />
      <img src={EVENT212AARRAYr} alt="foto" />
      <img src={EVENT212AARRAY} alt="foto" />
      <img src={EVENT210ASTACKR} alt="foto" />
      <img src={EVENT210ASTACK} alt="foto" />
      <img src={EVENT210AARRAYr} alt="foto" />
      <img src={EVENT210AARRAY} alt="foto" />
      <img src={EVENT26ASTACK} alt="foto" />
      <img src={EVENT26ASTACKr} alt="foto" />
      <img src={EVENT26AARRAYr} alt="foto" />
      <img src={EVENT26AARRAY} alt="foto" />
      <img src={ARCO4Tr} alt="foto" />
      <img src={ARCO4T} alt="foto" />
      <img src={ALTEACOMBOr} alt="foto" />
      <img src={ALTEACOMBO} alt="foto" />
      <img src={AERO50ARRAYr} alt="foto" />
      <img src={AERO50ARRAY} alt="foto" />
      <img src={AERO40ARRAYr} alt="foto" />
      <img src={AERO40ARRAY} alt="foto" />
      <img src={aero40r} alt="foto" />
      <img src={aero40} alt="foto" />
      <img src={action525ar} alt="foto" />
      <img src={action525a} alt="foto" />
      <img src={event26aside} alt="foto" />
      <img src={event26asideR} alt="foto" />
      <img src={event26a2r} alt="foto" />
      <img src={event26a2} alt="foto" />
      <img src={event26ar} alt="foto" />
      <img src={event26a} alt="foto" />
      <img src={piano2} alt="foto" />
      <img src={piano} alt="foto" />
      <img src={novationkeymini} alt="foto" />
      <img src={abletonpush} alt="foto" />
      <img src={baby3} alt="foto" />
      <img src={baby2} alt="foto" />
      <img src={baby} alt="foto" />
      <img src={NordDrum3P} alt="foto" />
      <img src={AkaiMpd218} alt="foto" />
      <img src={mikro2} alt="foto" />
      <img src={polyd} alt="foto" />
      <img src={moog} alt="foto" />
      <img src={korgvocal} alt="foto" />
      <img src={tche} alt="foto" />
      <img src={octapad} alt="foto" />
      <img src={bateriatop} alt="foto" />
      <img src={bateria1} alt="foto" />
      <img src={m7} alt="foto" />
      <img src={ls9} alt="foto" />
      <img src={groundsupport} alt="foto" />
      <img src={pantall4} alt="foto" />
      <img src={pantalla3} alt="foto" />
      <img src={pantalla2} alt="foto" />
      <img src={PANTALLA1} alt="foto" />
      <img src={PANTALLA} alt="foto" />
      <img src={tarima6} alt="foto" />
      <img src={tarima5} alt="foto" />
      <img src={tarima4} alt="foto" />
      <img src={tarima3} alt="foto" />
      <img src={silla1} alt="foto" />
      <img src={podio} alt="foto" />
      <img src={pantallagrande1} alt="foto" />
      <img src={pantallagrande} alt="foto" />
      <img src={muro2} alt="foto" />
      <img src={muro3} alt="foto" />
      <img src={motor2} alt="foto" />
      <img src={motor1} alt="foto" />
      <img src={layher13} alt="foto" />
      <img src={layher12} alt="foto" />
      <img src={layher11} alt="foto" />
      {/* <img src={layher10} alt="foto" /> */}
      {/* <img src={layher9} alt="foto" /> */}
      <img src={layher5} alt="foto" />
      <img src={layher4} alt="foto" />
      <img src={layher3} alt="foto" />
      <img src={layher8} alt="foto" />
      <img src={layher7} alt="foto" />
      <img src={layher6} alt="foto" />
      <img src={layher2} alt="foto" />
      <img src={layher1} alt="foto" />
      <img src={layher} alt="foto" />
      <img src={trus22} alt="foto" />
      <img src={trus21} alt="foto" />
      <img src={trus20} alt="foto" />
      <img src={trus18} alt="foto" />
      <img src={trus17} alt="foto" />
      <img src={trus16} alt="foto" />
      <img src={trus13} alt="foto" />
      <img src={trus12} alt="foto" />
      <img src={trus11} alt="foto" />
      <img src={trus10} alt="foto" />
      <img src={trus9} alt="foto" />
      <img src={trus8} alt="foto" />
      <img src={valla} alt="foto" />
      <img src={trus7} alt="foto" />
      <img src={trus6} alt="foto" />
      <img src={trus5} alt="foto" />
      <img src={trus4} alt="foto" />
      <img src={trus3} alt="foto" />
      <img src={trus2} alt="foto" />
      <img src={trus1} alt="foto" />
      <img src={trus} alt="foto" />
      <img src={tru6} alt="foto" />
      <img src={escalera5} alt="foto" />
      <img src={escalera4} alt="foto" />
      <img src={escalera3} alt="foto" />
      <img src={escalera2} alt="foto" />
      <img src={escalera1} alt="foto" />
      <img src={escalera} alt="foto" />
      <img src={movilbeam1} alt="foto" />
      <img src={movilbeam} alt="foto" />
      <img src={movil} alt="foto" />
      <img src={minibrut} alt="foto" />
      <img src={minibrut1} alt="foto" />
      <img src={luz12} alt="foto" />
      <img src={luz11} alt="foto" />
      <img src={luz10} alt="foto" />
      <img src={luz9} alt="foto" />
      <img src={luz8} alt="foto" />
      <img src={luz7} alt="foto" />
      <img src={luz6} alt="foto" />
      <img src={luz5} alt="foto" />
      <img src={luz4} alt="foto" />
      <img src={luz3} alt="foto" />
      <img src={luz2} alt="foto" />
      <img src={luz1} alt="foto" />
      <img src={luz} alt="foto" />
      <img src={LEKO5} alt="foto" />
      <img src={LEKO4} alt="foto" />
      <img src={LEKO3} alt="foto" />
      <img src={leko} alt="foto" />
      <img src={led} alt="foto" />
      <img src={flash} alt="foto" />
      <img src={barra2} alt="foto" />
      <img src={barra3} alt="foto" />
      <img src={barra} alt="foto" />
      <img src={barra1} alt="foto" />
      <img src={fuego1} alt="foto" />
      <img src={fuego} alt="foto" />
      <img src={cryo1} alt="foto" />
      <img src={cryo} alt="foto" />
      <img src={person1} alt="foto" />
      <img src={person2} alt="foto" />
      <img src={person3} alt="foto" />
      <img src={person4} alt="foto" />
      <img src={person5} alt="foto" />
      <img src={person6} alt="foto" />
      <img src={person7} alt="foto" />
      <img src={person8} alt="foto" />
      <img src={person9} alt="foto" />
      <img src={person10} alt="foto" />
      <img src={person11} alt="foto" />
      <img src={person12} alt="foto" />
      <img src={person13} alt="foto" />
      <img src={person14} alt="foto" />
      <img src={person15} alt="foto" />
      <img src={person16} alt="foto" />
      <img src={person17} alt="foto" />
      <img src={person18} alt="foto" />
      <img src={baila4} alt="foto" />
      <img src={baila3} alt="foto" />
      <img src={baila2} alt="foto" />
      <img src={baila1} alt="foto" />
      <img src={hombre1} alt="foto" />
      <img src={hombre} alt="foto" />
      <img src={mujer} alt="foto" />
      <img src={DiegoALaVoz} alt="foto" />
      <img src={AlexLaar} alt="foto" />
      <img src={zen} alt="foto" />
      <img src={julian} alt="foto" />
      <img src={jam} alt="foto" />
      <img src={morelo} alt="foto" />
      <img src={lebon} alt="foto" />

      <img src={camilo} alt="foto" />
      <img src={mau} alt="foto" />
      <img src={turizo} alt="foto" />
      <img src={zedgrande} alt="foto" />
      <img src={pasacable2} alt="foto" />
      <img src={body6} alt="foto" />
      <img src={body5} alt="foto" />
      <img src={body4} alt="foto" />
      <img src={body3} alt="foto" />
      <img src={body2} alt="foto" />
      <img src={body1} alt="foto" />
      <img src={iem1000} alt="foto" />
      <img src={iem2050} alt="foto" />
      <img src={zed1} alt="foto" />
      <img src={zed2} alt="foto" />
      <img src={p1} alt="foto" />
      <img src={p2} alt="foto" />
      <img src={uno} alt="foto" />
      <img src={dos} alt="foto" />
      <img src={tres} alt="foto" />
      <img src={cuatro1} alt="foto" />
      <img src={cinco} alt="foto" />
      <img src={seis} alt="foto" />
      <img src={siete} alt="foto" />
      <img src={ocho} alt="foto" />
      <img src={nueve} alt="foto" />
      <img src={diez} alt="foto" />
      <img src={once} alt="foto" />
      <img src={doce} alt="foto" />
      <img src={trece} alt="foto" />
      <img src={catorce} alt="foto" />
      <img src={quince} alt="foto" />
      <img src={diezseis} alt="foto" />
      <img src={diezsiete} alt="foto" />
      <img src={diezocho} alt="foto" />
      <img src={dieznueve} alt="foto" />
      <img src={veinte} alt="foto" />
      <img src={veinteuno} alt="foto" />
      <img src={veintedos} alt="foto" />
      <img src={veintetres} alt="foto" />
      <img src={veintecuatro} alt="foto" />
      <img src={veintecinco} alt="foto" />
      <img src={veinteseis} alt="foto" />
      <img src={veintesiete} alt="foto" />
      <img src={veinteocho} alt="foto" />
      <img src={veintenueve} alt="foto" />
      <img src={treinta} alt="foto" />
      <img src={treinta1} alt="foto" />
      <img src={treinta2} alt="foto" />
      <img src={treinta3} alt="foto" />
      <img src={treinta4} alt="foto" />
      <img src={treinta5} alt="foto" />
      <img src={treinta6} alt="foto" />
      <img src={treinta7} alt="foto" />
      <img src={treinta8} alt="foto" />
      <img src={treinta9} alt="foto" />
      <img src={cuarenta} alt="foto" />
      <img src={cuarenta1} alt="foto" />
      <img src={cuarenta2} alt="foto" />
      <img src={cuarenta3} alt="foto" />
      <img src={cuarenta4} alt="foto" />
      <img src={cuarenta5} alt="foto" />
      <img src={cuarenta6} alt="foto" />
      <img src={cuarenta7} alt="foto" />
      <img src={cuarenta8} alt="foto" />
      <img src={cuarenta9} alt="foto" />
      <img src={cincuenta} alt="foto" />
      <img src={cincuenta1} alt="foto" />
      <img src={cincuenta2} alt="foto" />
      <img src={cincuenta3} alt="foto" />
      <img src={cincuenta4} alt="foto" />
      <img src={cincuenta5} alt="foto" />
      <img src={cincuenta6} alt="foto" />
      <img src={cincuenta7} alt="foto" />
      <img src={cincuenta8} alt="foto" />
      <img src={cincuenta9} alt="foto" />
      <img src={sesenta} alt="foto" />
      <img src={sesenta1} alt="foto" />
      <img src={sesenta2} alt="foto" />
      <img src={sesenta3} alt="foto" />
      <img src={sesenta4} alt="foto" />
      <img src={sesenta5} alt="foto" />
      <img src={sesenta6} alt="foto" />
      <img src={sesenta7} alt="foto" />
      <img src={sesenta8} alt="foto" />
      <img src={sesenta9} alt="foto" />
      <img src={setenta} alt="foto" />
      <img src={setenta1} alt="foto" />
      <img src={setenta2} alt="foto" />
      <img src={setenta3} alt="foto" />
      <img src={setenta4} alt="foto" />
      <img src={setenta5} alt="foto" />
      <img src={setenta6} alt="foto" />
      <img src={setenta7} alt="foto" />
      <img src={setenta8} alt="foto" />
      <img src={setenta9} alt="foto" />
      <img src={ochenta} alt="foto" />
      <img src={ochenta1} alt="foto" />
      <img src={ochenta2} alt="foto" />
      <img src={ochenta3} alt="foto" />
      <img src={ochenta4} alt="foto" />
      <img src={ochenta5} alt="foto" />
      <img src={ochenta6} alt="foto" />
      <img src={ochenta7} alt="foto" />
      <img src={ochenta8} alt="foto" />
      <img src={ochenta9} alt="foto" />
      <img src={noventa} alt="foto" />
      <img src={noventa1} alt="foto" />
      <img src={noventa2} alt="foto" />
      <img src={noventa3} alt="foto" />
      <img src={noventa4} alt="foto" />
      <img src={noventa5} alt="foto" />
      <img src={noventa6} alt="foto" />
      <img src={noventa7} alt="foto" />
      <img src={noventa8} alt="foto" />
      <img src={noventa9} alt="foto" />
      <img src={cien} alt="foto" />

      <img src={pasiva} alt="foto" />
      <img src={tarima2} alt="foto" />
      <img src={toms1} alt="foto" />
      <img src={toms} alt="foto" />

      <img src={ACORDEONn} alt="foto" />
      <img src={ACORDEON1} alt="foto" />
      <img src={ACORDEON2} alt="foto" />
      <img src={ACORDEON3} alt="foto" />
      <img src={ACORDEON4} alt="foto" />
      <img src={ARPAA} alt="foto" />
      <img src={ARPA2} alt="foto" />
      <img src={BARITONO} alt="foto" />
      <img src={BARITONO1} alt="foto" />
      <img src={CONCERTINA} alt="foto" />
      <img src={CONCERTINA1} alt="foto" />
      <img src={CONTRABAJO} alt="foto" />
      <img src={CORNOFRANCES} alt="foto" />
      <img src={CORNOFRANCES2} alt="foto" />
      <img src={CORNOINGLES} alt="foto" />
      <img src={EUPHONIUM} alt="foto" />
      <img src={EUPHONIUM1} alt="foto" />
      <img src={FAGOT} alt="foto" />
      <img src={FLAUTATRAVERSA} alt="foto" />
      <img src={FLAUTINPICCOLO} alt="foto" />
      <img src={GAITA} alt="foto" />
      <img src={GONG} alt="foto" />
      <img src={GONG1} alt="foto" />
      <img src={GONG2} alt="foto" />
      <img src={HARMÓNICA} alt="foto" />
      <img src={MARIMBA} alt="foto" />
      <img src={MARIMBA1} alt="foto" />
      <img src={MARIMBA2} alt="foto" />
      <img src={MARIMBA3} alt="foto" />
      <img src={MELÓDICA} alt="foto" />
      <img src={MELÓDICA1} alt="foto" />
      <img src={OBOÉ} alt="foto" />
      <img src={OCARINA} alt="foto" />
      <img src={OCARINA1} alt="foto" />
      <img src={PLATILLOS} alt="foto" />
      <img src={PLATILLOS1} alt="foto" />
      <img src={SAXOBARITONO} alt="foto" />
      <img src={SAXOSOPRANO} alt="foto" />
      <img src={SITARA} alt="foto" />
      <img src={TIMPANO} alt="foto" />
      <img src={TIMPANO1} alt="foto" />
      <img src={TIMPANO2} alt="foto" />
      <img src={TIMPANO3} alt="foto" />
      <img src={TRIANGULO} alt="foto" />
      <img src={TRIANGULO1} alt="foto" />
      <img src={VIOLONCHELLO} alt="foto" />
      <img src={VIOLONCHELLO1} alt="foto" />
      <img src={XILOFON} alt="foto" />
      <img src={XILOFON1} alt="foto" />

      <img src={TIMBAL1} alt="foto" />
      <img src={UKULELE} alt="foto" />
      <img src={UKULELE1} alt="foto" />
      <img src={VIOLACAIPIRA} alt="foto" />
      <img src={VIOLACAIPIRA1} alt="foto" />
      <img src={VIOLÃO} alt="foto" />
      <img src={VIOLÃODEAÇO} alt="foto" />
      <img src={TIMBAL} alt="foto" />
      <img src={TIMBA3} alt="foto" />
      <img src={TIMBA2} alt="foto" />
      <img src={TIMBA1} alt="foto" />
      <img src={TIMBA} alt="foto" />
      <img src={TANTAN2} alt="foto" />
      <img src={TANTAN1} alt="foto" />
      <img src={TANTAN} alt="foto" />
      <img src={TAMBORIM3} alt="foto" />
      <img src={TAMBORIM2} alt="foto" />
      <img src={TAMBORIM1} alt="foto" />
      <img src={TAMBORIM} alt="foto" />
      <img src={SURDO1} alt="foto" />
      <img src={SURDO} alt="foto" />
      <img src={REPIQUEDEMÃO2} alt="foto" />
      <img src={REPIQUEDEMÃO1} alt="foto" />
      <img src={REPIQUEDEMÃO} alt="foto" />
      <img src={RECORECO} alt="foto" />
      <img src={RECORECO1} alt="foto" />
      <img src={REBOLO} alt="foto" />
      <img src={PANDEIRO1} alt="foto" />
      <img src={PANDEIRO} alt="foto" />
      <img src={GANZAXÉ} alt="foto" />
      <img src={GANZÁDEPLATINELA1} alt="foto" />
      <img src={GANZÁDEPLATINELA} alt="foto" />
      <img src={GANZÁ1} alt="foto" />
      <img src={GANZÁ} alt="foto" />
      <img src={CUICA1} alt="foto" />
      <img src={CUICA} alt="foto" />
      <img src={CAVAQUINHO2} alt="foto" />
      <img src={CAVAQUINHO} alt="foto" />
      <img src={CAIXAREPIQUE2} alt="foto" />
      <img src={CAIXAREPIQUE1} alt="foto" />
      <img src={BERIMBAU2} alt="foto" />
      <img src={BERIMBAU1} alt="foto" />
      <img src={BERIMBAU} alt="foto" />
      <img src={BANJO} alt="foto" />
      <img src={AGOGÔTRIPLO3} alt="foto" />
      <img src={AGOGÔTRIPLO2} alt="foto" />
      <img src={AGOGÔDUPLO1} alt="foto" />
      <img src={AGOGÔDUPLO} alt="foto" />
      <img src={AFUXÉCABAÇA4} alt="foto" />
      <img src={AFUXÉCABAÇA3} alt="foto" />
      <img src={AFUXÉCABAÇA2} alt="foto" />
      <img src={AFUXÉCABAÇA1} alt="foto" />
      <img src={AFUXÉCABAÇA} alt="foto" />

      <img src={GUITARRABAJOSEXTO} alt="foto" />
      <img src={GUITARRABAJOSEXTO1} alt="foto" />
      <img src={GUITARRABAJOSEXTO2} alt="foto" />
      <img src={GUITARRON} alt="foto" />
      <img src={VIHUELA} alt="foto" />

      <img src={dj1} alt="foto" />
      <img src={dj2} alt="foto" />
      <img src={dj3} alt="foto" />
      <img src={dj4} alt="foto" />
      <img src={dj5} alt="foto" />
      <img src={dj6} alt="foto" />
      <img src={dj7} alt="foto" />
      <img src={dj8} alt="foto" />
      <img src={dj9} alt="foto" />
      <img src={dj10} alt="foto" />
      <img src={dj11} alt="foto" />
      <img src={dj12} alt="foto" />
      <img src={dj13} alt="foto" />
      <img src={dj14} alt="foto" />
      <img src={dj15} alt="foto" />
      <img src={dj16} alt="foto" />
      <img src={dj17} alt="foto" />
      <img src={dj18} alt="foto" />

      <img src={wingbehringer} alt="foto" />
      <img src={x32producer} alt="foto" />
      <img src={x32rack} alt="foto" />

      <img src={sm57} alt="foto" />
      <img src={condenser} alt="foto" />
      <img src={condenser1} alt="foto" />
      <img src={condenser2} alt="foto" />
      <img src={condenser3} alt="foto" />
      <img src={condenser4} alt="foto" />
      <img src={condenser5} alt="foto" />
      <img src={condenser6} alt="foto" />
      <img src={condenser7} alt="foto" />
      <img src={condenser8} alt="foto" />
      <img src={condenser9} alt="foto" />
      <img src={condenser10} alt="foto" />
      <img src={condenser11} alt="foto" />
      <img src={condenser12} alt="foto" />
      <img src={condenser13} alt="foto" />

      <img src={v102} alt="foto" />
      <img src={v102L} alt="foto" />
      <img src={v101} alt="foto" />
      <img src={v101L} alt="foto" />
      <img src={v10} alt="foto" />
      <img src={v10L} alt="foto" />
      <img src={v7} alt="foto" />
      <img src={v7L} alt="foto" />
      <img src={substs} alt="foto" />
      <img src={substsL} alt="foto" />
      <img src={sts1} alt="foto" />
      <img src={sts1L} alt="foto" />
      <img src={stsmoni} alt="foto" />
      <img src={monitorsts} alt="foto" />
      <img src={monitorstsL} alt="foto" />
      <img src={mikra8L} alt="foto" />
      <img src={mikra8} alt="foto" />
      <img src={pasacable} alt="foto" />

      <img src={alfombra} alt="foto" />
      <img src={alfombra2} alt="foto" />
      <img src={multipin} alt="foto" />
      <img src={tarima1} alt="foto" />
      <img src={tarima} alt="foto" />
      <img src={linea5} alt="foto" />
      <img src={linea1} alt="foto" />
      <img src={linea2} alt="foto" />
      <img src={linea3} alt="foto" />
      <img src={linea4} alt="foto" />
      <img src={linea} alt="foto" />
      <img src={flecha1} alt="foto" />
      <img src={flecha2} alt="foto" />
      <img src={flecha3} alt="foto" />
      <img src={flecha4} alt="foto" />
      <img src={flecha} alt="foto" />
      <img src={pedal1} alt="foto" />
      <img src={pedal2} alt="foto" />
      <img src={pedal12} alt="foto" />
      <img src={pedal8} alt="foto" />
      <img src={pedal11} alt="foto" />
      <img src={MOSEÑO} alt="foto" />
      <img src={tarka} alt="foto" />
      <img src={ZAMPOÑACROMATICA} alt="foto" />
      <img src={BOMBOFOLCLORICO} alt="foto" />
      <img src={BOMBOITALAQUE} alt="foto" />
      <img src={corriente1} alt="foto" />
      <img src={Soundgraft} alt="foto" />
      <img src={mr18} alt="foto" />
      <img src={Guitarra2} alt="foto" />
      <img src={guitarron} alt="foto" />
      <img src={Vihuela} alt="foto" />
      <img src={MANDOLINA} alt="foto" />
      <img src={mandolinmandolina} alt="foto" />
      <img src={Apollo} alt="foto" />
      <img src={GTO} alt="foto" />
      <img src={GaetanoBT} alt="foto" />
      <img src={GaetanoBC} alt="foto" />
      <img src={ampegpantalla} alt="foto" />
      <img src={ampegcabezal} alt="foto" />
      <img src={ampegcmbo} alt="foto" />
      <img src={aguilarcabezal} alt="foto" />
      <img src={ampegamp} alt="foto" />
      <img src={ampegpantalla2} alt="foto" />
      <img src={amphartec} alt="foto" />
      <img src={amphartec2} alt="foto" />
      <img src={ampmark} alt="foto" />
      <img src={cabezal} alt="foto" />
      <img src={gabinetemarshall} alt="foto" />
      <img src={orangecabezal} alt="foto" />
      <img src={orangepantalla} alt="foto" />
      <img src={vox} alt="foto" />
      <img src={marshall} alt="foto" />
      <img src={fender1} alt="foto" />
      <img src={amplificador} alt="foto" />
      <img src={cajadirecta} alt="foto" />
      <img src={cajadirecta1} alt="foto" />
      <img src={spliter} alt="foto" />
      <img src={solidrums} alt="foto" />
      <img src={solidrums2} alt="foto" />
      <img src={solidrums3} alt="foto" />
      <img src={TamboradegaitaZuliana} alt="foto" />
      <img src={tamboramexicana} alt="foto" />
      <img src={tamborescumaco} alt="foto" />
      <img src={accesorios1} alt="foto" />
      <img src={silla} alt="foto" />
      <img src={ACORDEON} alt="foto" />
      <img src={bandoneon1} alt="foto" />
      <img src={bandoneon} alt="foto" />
      <img src={acordeon1} alt="foto" />
      <img src={ARPA} alt="foto" />

      <img src={VIOLIN} alt="foto" />
      <img src={violin1} alt="foto" />
      <img src={violin2} alt="foto" />
      <img src={OCTAPAD} alt="foto" />
      <img src={palodelluvia} alt="foto" />
      <img src={pezuñas} alt="foto" />
      <img src={bateriaelectronica} alt="foto" />
      <img src={palinear} alt="foto" />
      <img src={palinearL} alt="foto" />
      <img src={sublinear} alt="foto" />
      <img src={sublinearL} alt="foto" />
      <img src={sts} alt="foto" />
      <img src={stsL} alt="foto" />
      <img src={stanitch} alt="foto" />
      <img src={stanitchL} alt="foto" />
      <img src={sonataL} alt="foto" />
      <img src={sonata} alt="foto" />
      <img src={side2} alt="foto" />
      <img src={side2L} alt="foto" />
      <img src={peitsch} alt="foto" />
      <img src={monitoL} alt="foto" />
      <img src={monito} alt="foto" />
      <img src={moni} alt="foto" />
      <img src={triplebell} alt="foto" />
      <img src={timbal2} alt="foto" />
      <img src={timbal1} alt="foto" />
      <img src={tambourine2} alt="foto" />
      <img src={tambourine} alt="foto" />
      <img src={shekere} alt="foto" />
      <img src={shaker} alt="foto" />
      <img src={maraca1} alt="foto" />
      <img src={hoopdrum} alt="foto" />
      <img src={guiro} alt="foto" />
      <img src={guira2} alt="foto" />
      <img src={guira} alt="foto" />
      <img src={djembe2} alt="foto" />
      <img src={djembe} alt="foto" />
      <img src={darbuka} alt="foto" />
      <img src={cowbell} alt="foto" />
      <img src={chime} alt="foto" />
      <img src={trompeta} alt="foto" />
      <img src={trombom} alt="foto" />
      <img src={saxofon} alt="foto" />
      <img src={PIFILKA} alt="foto" />
      <img src={armonica} alt="foto" />
      <img src={trutuka} alt="foto" />
      <img src={ÑOLKIN} alt="foto" />
      <img src={ZAMPOÑA} alt="foto" />
      <img src={SIKU2} alt="foto" />
      <img src={SIKU} alt="foto" />
      <img src={saxotenor} alt="foto" />
      <img src={saxosoprano} alt="foto" />
      <img src={saxoalto} alt="foto" />
      <img src={quena1} alt="foto" />
      <img src={QUENA} alt="foto" />
      <img src={Charcheta} alt="foto" />
      <img src={flauta3} alt="foto" />
      <img src={flauta} alt="foto" />
      <img src={clarinete} alt="foto" />
      <img src={tuba} alt="foto" />
      <img src={cajon} alt="foto" />
      <img src={cajon1} alt="foto" />
      <img src={bongo3} alt="foto" />
      <img src={block} alt="foto" />
      <img src={conga3} alt="foto" />
      <img src={conga2} alt="foto" />
      <img src={conga1} alt="foto" />
      <img src={bongo1} alt="foto" />
      <img src={kultrum} alt="foto" />
      <img src={bomboleguero} alt="foto" />
      <img src={REDOBLANTE} alt="foto" />
      <img src={hihat1} alt="foto" />
      <img src={PLATILLO} alt="foto" />
      <img src={tambores} alt="foto" />
      <img src={TAMBORADOMINICANA} alt="foto" />
      <img src={zurdo} alt="foto" />
      <img src={accesorios} alt="foto" />
      <img src={congadoble2} alt="foto" />
      <img src={congadoble} alt="foto" />
      <img src={antena1} alt="foto" />
      <img src={antena} alt="foto" />
      <img src={helicoidal} alt="foto" />
      <img src={antena1L} alt="foto" />
      <img src={antenaL} alt="foto" />
      <img src={helicoidalL} alt="foto" />
      <img src={mano} alt="foto" />
      <img src={manoshure} alt="foto" />
      <img src={sm58} alt="foto" />
      <img src={stand} alt="foto" />
      <img src={stand1} alt="foto" />
      <img src={stand2} alt="foto" />
      <img src={directbox3} alt="foto" />
      <img src={directbox2} alt="foto" />
      <img src={directbox1} alt="foto" />
      <img src={snake12cha} alt="foto" />
      <img src={soundtools} alt="foto" />
      <img src={snake8cha} alt="foto" />
      <img src={x32} alt="foto" />
      <img src={sq6} alt="foto" />
      <img src={s6l} alt="foto" />
      <img src={corriente} alt="foto" />
      <img src={mac} alt="foto" />
      <img src={gibson} alt="foto" />
      <img src={guitarraelectrica} alt="foto" />
      <img src={guitarraelectricaprs} alt="foto" />
      <img src={ibanez} alt="foto" />
      <img src={lespaul} alt="foto" />
      <img src={vanhalen} alt="foto" />
      <img src={cuatro} alt="foto" />
      <img src={guitarra} alt="foto" />
      <img src={guitarra1} alt="foto" />
      <img src={RONROCO} alt="foto" />
      <img src={charango} alt="foto" />
      <img src={bateria1tom} alt="foto" />
      <img src={bateria2bombo} alt="foto" />
      <img src={bateria2tom} alt="foto" />
      <img src={bateria3tom} alt="foto" />
      <img src={bateria4tom} alt="foto" />
      <img src={bateria5tom} alt="foto" />
      <img src={bajogl} alt="foto" />
      <img src={fender} alt="foto" />
      <img src={fenderviolet} alt="foto" />
      <img src={gl} alt="foto" />
      <img src={ibanezbass} alt="foto" />
      <img src={ibanezbasses} alt="foto" />
      <img src={korg} alt="foto" />
      <img src={montage} alt="foto" />
      <img src={motif} alt="foto" />
      <img src={nordstage} alt="foto" />
      <img src={roland2} alt="foto" />
      <img src={roland} alt="foto" />
      <img src={monitordb} alt="foto" />
      <img src={monitordbL} alt="foto" />
      <img src={monitor} alt="foto" />
      <img src={monitorL} alt="foto" />
      <img src={sidefill4} alt="foto" />
      <img src={sidefill4L} alt="foto" />
      <img src={sidefillarray} alt="foto" />
      <img src={sidefillarrayL} alt="foto" />
      <img src={sidefillpuntual} alt="foto" />
      <img src={sidefillpuntualL} alt="foto" />
      <img src={sidefillt} alt="foto" />
      <img src={sidefilltL} alt="foto" />
      <img src={sidetw} alt="foto" />
      <img src={sidetwL} alt="foto" />
      <img src={substanitch} alt="foto" />
      <img src={substanitchL} alt="foto" />
      <img src={c3500} alt="foto" />
      <img src={cl5} alt="foto" />
      <img src={sd10} alt="foto" />
      <img src={wings} alt="foto" />
      <img src={lv1} alt="foto" />
    </>
  );
};

export default images;
